import { nonNullableValue } from '~shared/lib/non-nullable-value/non-nullable-value';

import {
  keepPreviousData,
  skipToken,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';

import {
  getGraphData,
  getTableDataByMerchant,
  getTableDataByPos,
} from './gateway';
import type { SummaryTableParameters } from './summary-api';

import type { GroupByField } from '../summary';
import type {
  TransactionsSummaryFilter,
  TransactionsSummaryItem,
} from '../summary.dto';

export const useGetSummaryGraphQuery = (filter?: TransactionsSummaryFilter) => {
  return useQuery({
    queryKey: ['get-graph', filter],
    queryFn: filter ? async () => getGraphData({ filter: filter }) : skipToken,
    placeholderData: keepPreviousData,
  });
};

export const useGetSummaryTableQuery = (
  type: GroupByField,
  requestOptions: SummaryTableParameters,
  options: Omit<
    UseQueryOptions<{
      items: TransactionsSummaryItem[];
      total: number;
    }>,
    'queryKey' | 'queryFn'
  > = {}
) => {
  return useQuery({
    ...options,
    queryKey: ['find-summary', requestOptions, type],
    queryFn: async () => {
      const { items, pageInfo } = await (type === 'by-merchant'
        ? getTableDataByMerchant(nonNullableValue(requestOptions))
        : getTableDataByPos(nonNullableValue(requestOptions)));

      return {
        items,
        total: pageInfo.total,
      };
    },
    placeholderData: keepPreviousData,
  });
};
